import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { imageCdnAsset } from 'lib/common/url-helpers';
import Brand from 'models/brand';

import Checkmark from 'components/svgs/icons/checkmark';
import BrandName from 'containers/common/brand-name';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const defaultProps = {

};

const NoBookingsPurchased = ({ brand }) => {
  const parkingBenefits = [
    'Up to 50% off drive-up rates',
    'Advanced booking',
    'Clear directions',
    'A mobile pass you can access on your phone',
    'An automated receipt',
  ];
  const buttonClasses = cx({
    'btn': true,
    'btn-lg': true,
    'btn-primary': true,
    'btn-block': true,
    'btn-bp': brand.isBestParking,
  });

  return (
    <div className="light-content no-bookings-purchased margin-top-xs-20 margin-top-md-80">
      <h3 className="h3 xs-align-center top">Need a Reservation?</h3>
      <div className="row">
        <div className="col-md-6 col-md-push-6">
          <img src={imageCdnAsset('/images/bookings/booking-instruction.png')} alt="Booking Instructions" />
        </div>
        <div className="col-md-6 col-md-pull-6">
          <p>Holy Tire Tracks! We have no reservation on file for you. Act now and get:</p>
          <ul className="list-unstyled">
            { parkingBenefits.map((benefit, i) => (
              <li key={i}><Checkmark />{ benefit }</li>
            )) }
          </ul>
          <p className="xs-align-center">
            Book now with <BrandName />.&nbsp;
            <br className="visible-xs" />
            We&apos;ll save a spot for ya!
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-5">
          <a href="/" className={buttonClasses}>Book Now</a>
        </div>
      </div>
    </div>
  );
};

NoBookingsPurchased.propTypes = propTypes;
NoBookingsPurchased.defaultProps = defaultProps;

export default NoBookingsPurchased;
